const PERFORMANCE_SLUG_MARKER = "entradas-";

/**
 * `slug2` con esta marca **al inicio** ⇒ ficha de evento (PDP) — p. ej.
 * `entradas-ikono-barcelona`. Sin ella, es una página del CMS de 2 segmentos
 * (p. ej. `/promocion/ocho-dias-de-oro-teatro-y-musicales/`).
 *
 * `startsWith`, no `includes`: una subcategoría real cuyo slug contuviera
 * `entradas-` en mitad de la cadena no debe confundirse con una ficha de
 * evento (specs/030-pdp-ficha-evento, Edge Cases).
 */
export function isPerformanceSlug(slug2: string): boolean {
  return slug2.startsWith(PERFORMANCE_SLUG_MARKER);
}

/**
 * ¿Este `pathname` completo es una ficha de evento (PDP)?
 *
 * La ficha vive en `/entradas/{categoria}/entradas-{evento}/`: exactamente dos
 * segmentos tras `entradas/`, con el segundo marcado. Se exige la posición
 * concreta —y no un `includes`— para no confundirla con rutas más profundas ni
 * con otras que contengan la marca en otro nivel.
 *
 * Lo usa el header para ocultar su buscador en la ficha
 * (specs/043-pagina-de-producto, FR-052/FR-053) sin tener que propagar un dato
 * de servidor hasta un componente de layout compartido por todo el sitio.
 */
export function isPerformancePathname(pathname: string): boolean {
  const segments = pathname.split("/").filter(Boolean);
  if (segments[0] !== "entradas") return false;
  if (segments.length !== 3) return false;
  return isPerformanceSlug(segments[2] ?? "");
}
